"use client";

// 2026-05-26: Reusable in-form notice rendered IN PLACE of the trade
// inputs when the user is in a Polymarket-blocked region. Used by:
//   • TradingModal (popup BUY/SELL flow)
//   • TradingPanel (sidebar on /event/* + /market/* pages)
//
// Keep this as a single source of truth so the copy and styling stay
// consistent across surfaces.

import { ShieldAlert } from "lucide-react";

interface Props {
  /** Country / region label, e.g. "US / CA". Optional. */
  regionLabel?: string | null;
}

export default function PolymarketGeoblockedNotice({ regionLabel }: Props) {
  return (
    // Full-width card so the sidebar / modal usage matches sibling
    // panels (OpenOrders, OrderBook) — same rounded-[5px], same border
    // weight, tinted red instead of neutral. No outer padding wrapper:
    // the parent container (TradingPanel slot / TradingModal body) owns
    // the spacing.
    <div className="rounded-[5px] border border-red-500/20 bg-red-500/[0.04] dark:bg-red-500/[0.06] p-6 flex flex-col items-center text-center gap-3">
      <ShieldAlert className="w-9 h-9 text-red-500/80 dark:text-red-400" strokeWidth={1.5} />
      <h4 className="text-base font-semibold text-gray-900 dark:text-white">
        Not available in your region
      </h4>
      <p className="text-sm text-gray-600 dark:text-gray-400">
        Polymarket does not accept trades from
        {regionLabel ? ` ${regionLabel}` : " your region"}.
        You can still view markets and close existing positions, but
        new orders would be rejected at the CLOB.
      </p>
      <a
        href="https://docs.polymarket.com/api-reference/geoblock"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white underline mt-1"
      >
        Polymarket geographic restrictions
      </a>
    </div>
  );
}
